import type { HotOffer } from '@shared/api/types/hotOffers';
import NextLink from '@shared/common/components/NextLink';

import UserHotOfferCard from './UserHotOfferCard';

interface UserHotOffersProps {
  hotOffers: HotOffer[];
  seeAllHref: string;
}

const UserHotOffers = ({ hotOffers, seeAllHref }: UserHotOffersProps) => {
  return (
    <div>
      <div className="flex justify-between items-start pb-4">
        <h2 className="t-h5 font-bold">Claimed Hot Offers</h2>
        <NextLink
          href={seeAllHref}
          className="text-base transition-colors text-primary-600 hover:text-primary-700 whitespace-nowrap"
          data-qa="apps-block-see-all-button"
        >
          See all ››
        </NextLink>
      </div>
      {!!hotOffers.length && (
        <div className="grid lg:grid-cols-2 gap-4" data-qa="hot-offers-grid">
          {hotOffers.map((offer) => {
            return <UserHotOfferCard key={offer.id} offer={offer} />;
          })}
        </div>
      )}
      {!hotOffers.length && (
        <div className="w-full py-8">
          <h3 className="t-h4 text-center text-neutral-300">Empty!</h3>
        </div>
      )}
    </div>
  );
};

export default UserHotOffers;
